import { DOCUMENT } from '@angular/common';
import { Component, Inject, Input, OnDestroy, OnInit, Renderer2, ViewEncapsulation } from '@angular/core';

import { TaskListModeEnum } from '../shared/enums';
import { TaskListConfiguration } from '../shared/models';

@Component({
  selector: 'app-inbox',
  templateUrl: './inbox.component.html',
  styleUrls: ['./inbox.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class InboxComponent implements OnInit, OnDestroy {
  @Input() taskListConfiguration: TaskListConfiguration;

  parentContainer: HTMLElement;
  parentContainerId = 'right-side-content';
  ngInboxClass = 'ng-inbox';
  taskListMode = TaskListModeEnum.Inbox;

  constructor(private renderer: Renderer2, @Inject(DOCUMENT) public document: Document) {
    this.parentContainer = this.document.getElementById(this.parentContainerId);
  }

  ngOnInit(): void {
    this.renderer.addClass(this.parentContainer, this.ngInboxClass);
  }

  ngOnDestroy(): void {
    this.renderer.removeClass(this.parentContainer, this.ngInboxClass);
  }
}
